import {CharacterProfession} from './CharacterProfessionsEnum';

export const characterProfessionsArray: CharacterProfession[] = [
    CharacterProfession.Runeblade,
    CharacterProfession.Aethermancer,
    CharacterProfession.Lifeweaver,
];
